import * as token from "@universityofmaryland/web-token-library";
import { debounce } from "@universityofmaryland/web-utilities-library/performance";
import { createCompositeMediaCaption } from "../elements/caption.js";
import { layoutImage } from "../../../layout/image.js";
import "@universityofmaryland/web-builder-library";
import "@universityofmaryland/web-styles-library";
const BREAKPOINT = 400;
const ATTRIBUTE_IS_WRAPPING_TEXT = "is-wrapping-text";
const ELEMENT_MEDIA_INLINE_CONTAINER = "element-media-inline-wrapped-container";
const ELEMENT_OBJECT_WRAPPED_CONTAINER = "element-object-wrapped-container";
const ObjectContainer = `
  .${ELEMENT_OBJECT_WRAPPED_CONTAINER} {
    display: inline-block;
    padding-bottom: ${token.spacing.sm};
    max-width: 100%;
  }
`;
const STYLES_MEDIA_INLINE_WRAPPED_ELEMENT = `
  .${ELEMENT_MEDIA_INLINE_CONTAINER} {
    display: inline-block;
    max-width: 100%;
  }

  ${layoutImage.Styles}
  ${createCompositeMediaCaption.Styles}
  ${ObjectContainer}
`;
const GetObjectSize = ({
  elementContainer,
  image
}) => {
  const containerSize = elementContainer.offsetWidth;
  const imageWidth = image.naturalWidth;
  const isMediumView = containerSize > BREAKPOINT;
  let width = imageWidth;
  if (isMediumView) {
    const shouldMaxSized = imageWidth > containerSize / 2;
    if (shouldMaxSized) width = containerSize / 2;
  }
  return width;
};
const CreateMediaInlineWrapped = (props) => (() => {
  const { image, isAlignmentRight, isThemeDark, caption, wrappingText } = props;
  const elementContainer = document.createElement("div");
  const objectContainer = document.createElement("div");
  const hasWrappingtext = wrappingText && wrappingText !== null;
  const hasCaption = caption && caption !== null;
  const sizeCaption = () => {
    const imageContainer = elementContainer.querySelector(
      `.${layoutImage.Elements.container}`
    );
    const caption2 = elementContainer.querySelector(
      `.${createCompositeMediaCaption.Elements.container}`
    );
    if (caption2) {
      caption2.style.width = `${imageContainer.offsetWidth}px`;
    }
  };
  const sizeObject = () => {
    const isAboveBreakPoint = elementContainer.offsetWidth > BREAKPOINT;
    const objectContainer2 = elementContainer.querySelector(
      `.${ELEMENT_OBJECT_WRAPPED_CONTAINER}`
    );
    if (!image) return;
    if (isAboveBreakPoint) {
      const objectSize = GetObjectSize({ elementContainer, image });
      objectContainer2.style.width = `${objectSize}px`;
      objectContainer2.style.display = "inline-block";
      objectContainer2.style.textAlign = "left";
      if (isAlignmentRight) {
        objectContainer2.style.float = `right`;
        objectContainer2.style.paddingLeft = `${token.spacing.md}`;
      } else {
        objectContainer2.style.float = "left";
        objectContainer2.style.paddingRight = `${token.spacing.md}`;
      }
    } else {
      objectContainer2.style.width = "100%";
      objectContainer2.style.float = "none";
      objectContainer2.style.textAlign = "center";
      objectContainer2.style.paddingLeft = `0`;
      objectContainer2.style.paddingRight = `0`;
    }
    setTimeout(() => {
      sizeCaption();
    }, 100);
  };
  const eventResize = () => {
    if (hasWrappingtext) {
      sizeObject();
    }
    if (hasCaption) {
      sizeCaption();
    }
  };
  const load = () => {
    const checkSizing = () => {
      const caption2 = objectContainer.querySelector(
        `.${createCompositeMediaCaption.Elements.container}`
      );
      if (caption2) {
        caption2.style.opacity = `1`;
      }
    };
    image?.addEventListener("load", () => {
      eventResize();
      setTimeout(() => {
        checkSizing();
      }, 100);
      setTimeout(() => {
        checkSizing();
      }, 500);
    });
  };
  objectContainer.classList.add(ELEMENT_OBJECT_WRAPPED_CONTAINER);
  if (image) {
    objectContainer.appendChild(
      layoutImage.CreateElement({
        image,
        showCaption: true
      })
    );
  }
  if (hasCaption) {
    const captionElement = createCompositeMediaCaption.CreateElement({
      caption,
      isThemeDark
    });
    captionElement.style.opacity = `0`;
    objectContainer.appendChild(captionElement);
  }
  if (objectContainer.children.length > 0) {
    elementContainer.appendChild(objectContainer);
  }
  if (hasWrappingtext) {
    elementContainer.appendChild(wrappingText);
    elementContainer.setAttribute(ATTRIBUTE_IS_WRAPPING_TEXT, "");
    setTimeout(() => {
      sizeObject();
    }, 100);
  }
  elementContainer.classList.add(ELEMENT_MEDIA_INLINE_CONTAINER);
  window.addEventListener(
    "resize",
    debounce(() => {
      eventResize();
    }, 20)
  );
  setTimeout(() => {
    eventResize();
  }, 200);
  return {
    element: elementContainer,
    events: {
      load
    },
    styles: STYLES_MEDIA_INLINE_WRAPPED_ELEMENT
  };
})();
const createCompositeMediaInlineWrapped = CreateMediaInlineWrapped;
export {
  createCompositeMediaInlineWrapped
};
//# sourceMappingURL=wrapped.js.map
